import { BASE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetUserPricingSnapshotV2(userId) {
    const api = `${BASE_API}v2/users/${userId}/pricing/snapshot/`;
    return axiosHttp.get(api, { params: { includePriceUpdate: true } });
}